import { SVGCross } from "@/lib/svg";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.5rem 1rem;
  border-bottom: solid 1px;
  border-color: ${({ theme }) => theme.colors.middleGrey};
`;

export const Title = styled.span`
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-style: normal;
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.2;
`;

export const Icon = styled(SVGCross)`
  width: 1rem;
  cursor: pointer;
`;
